import classnames from 'classnames';
import { map } from 'ramda';
import React, { FC, useMemo } from 'react';
import { Tag } from '../../../../../../../components/common';
import { convertLabels } from '../utils';
import styles from './LabelsViewer.scss';
import { IOuter } from './LabelsViewer.types';

export const LabelsViewer: FC<IOuter> = ({
  className,
  labels: labelsFromProps,
  onLabelClick,
  dataHook = 'labels-viewer',
}) => {
  const labels = useMemo(() => convertLabels(labelsFromProps), [labelsFromProps]);

  return (
    <div className={classnames(styles.viewer, className)} data-hook={dataHook}>
      {map(
        ({ id, label }) => (
          <Tag
            key={id}
            className={styles.label}
            id={id}
            onClick={onLabelClick}
            size="small"
            maxWidth={180}
            removable={false}
            dataHook="tag"
          >
            {label}
          </Tag>
        ),
        labels,
      )}
    </div>
  );
};
